import {IFormField} from './formField.interface';

import {Component, Inject, Input, Output, EventEmitter} from 'ng-metadata/core';
import {FormFieldService} from './formField.service';
import {FormBuilderEnums} from '../formBuilder.service';
import {MediaQueries} from '../../mediaQueries.service';
import {RequestService} from '../../../search/fullView/getit/opac/request/request.service';
//your imports go here
var angular: angular.IAngularStatic = require('angular');
const forEach = require('lodash/forEach');
const uniqBy = require('lodash/uniqBy');
const uniq = require('lodash/uniq');
const getValue = require('lodash/get')
const dateFormat = require('dateformat');

@Component({
    selector: 'prm-form-field',
    templateUrl: 'components/infra/formBuilder/field/form-field.html'
})


export class PrmFormField {

    @Input() public field: IFormField;
    @Input() public data;
    @Input() public form: Object;
    @Input() public repeatablecounter;
    @Input() public isRequestSubmitted : boolean;
    @Output() private buttonClicked = new EventEmitter();

    public filterDates = angular.bind(this, this.filterDatesUnbound);

    private fieldUiTypeHtml: Object;


    /* date dropdown */
    private days: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'
        , '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
    private months: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    private hours: string[] = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'
        , '21', '22', '23'];
    private minutes: string[] = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'
        , '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46',
        '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];
    private yearRegex = '\\d+';

    private delayForLabels: boolean = false;

    private filterSearchTerm: string;

    constructor(private requestService: RequestService,
                private formFieldService: FormFieldService,
                @Inject('actionIcons') public actionIcons,
                @Inject('$timeout') private $timeout,
                @Inject('$filter') private $filter: ng.IFilterService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private mediaQueries: MediaQueries) {
        this.fieldUiTypeHtml = {
            text: 'components/infra/formBuilder/field/form-field-text.html',
            textarea: 'components/infra/formBuilder/field/form-field-textarea.html',
            textarearepeatable: 'components/infra/formBuilder/field/form-field-textarea-repeatable.html',
            textrepeatable: 'components/infra/formBuilder/field/form-field-text-repeatable.html',
            checkbox: 'components/infra/formBuilder/field/form-field-checkbox.html',
            readonly: 'components/infra/formBuilder/field/form-field.html',
            password: 'components/infra/formBuilder/field/form-field.html',
            dropdown: 'components/infra/formBuilder/field/form-field-dropdown.html',
            dropdownWithFilterSearch: 'components/infra/formBuilder/field/form-field-dropdown-with-filter-search.html',
            dropdownrepeatable: 'components/infra/formBuilder/field/form-field-dropdown-repeatable.html',
            comboboxmultiplenew: 'components/infra/formBuilder/field/form-field-multiselectdropdown.html',
            radio: 'components/infra/formBuilder/field/form-field-radio.html',
            date: 'components/infra/formBuilder/field/form-field-date.html',
            daterepeatable: 'components/infra/formBuilder/field/form-field-date-repeatable.html',
            label: 'components/infra/formBuilder/field/form-field-label.html',
            interactableLabel: 'components/infra/formBuilder/field/form-field-label.html',
            multiLabel: 'components/infra/formBuilder/field/form-field-multi-label.html',
            hidden: 'components/infra/formBuilder/field/form-field-hidden.html',
            link: 'components/infra/formBuilder/field/form-field-link.html',
            datetime: 'components/infra/formBuilder/field/form-field-datetime.html',
            dateAndHours: 'components/infra/formBuilder/field/form-field-dateAndHours.html',
            dateAndTime: 'components/infra/formBuilder/field/form-field-dateAndTime.html',
            dateDropdown: 'components/infra/formBuilder/field/form-field-date-dropdown.html',
            dateNgrs: 'components/infra/formBuilder/field/form-field-date-needed-by.html',
            buttonAndText: 'components/infra/formBuilder/field/form-field-buttonAndText.html',
        };
        /*There is a bug in angular-material that sometimes labels aren't presented because that 'translate' in the <label> with the combination
        of the drop down didn't finish to load*/
        this.$timeout(() => {
            this.delayForLabels = true
        }, 400);
    }

    ngOnInit() {
        this.$timeout(() => {
            this.setAriaRequiredAttribute();
        }, 200);
    }

    public expandList(id) {
        document.querySelector('*[name="' + this.field.name + '"]').click();
    }


    /* getter / setter */
    get formData() {
        return this.data;
    }

    set formData(data) {
        this.data = data;
    }

    get repeatableCounter() {
        return this.repeatablecounter;
    }

    set repeatableCounter(repeatablecounter) {
        this.repeatablecounter = repeatablecounter;
    }

    get limit() {
        return this.repeatablecounter[this.field.name];
    }

    public getValuesForTranslation() {
        if (this.field.name === 'calculateQueueButton')
            return {idx_0: this.field.options.numInQueue};
        return undefined;
    }

    public incrementLimit(index) {
        this.repeatablecounter[this.field.name] += 1;
        var prevVal = '';
        var passVal = '';
        for (var i = index + 1; i <= this.limit; i++) {
            var j = i + 1;
            prevVal = this.formData[this.field.name + i];
            this.formData[this.field.name + i] = passVal;
            passVal = prevVal;
        }
    }

    private labelColor(bookChapterLable : String) {
        return bookChapterLable !== 'almaResourceSharing.specificChapterPages';
    }

    public decreaseLimit(index) {
        this.formData[this.field.name + index] = "";
        for (var i = index; i < this.limit; i++) {
            var j = i + 1;
            this.formData[this.field.name + i] = this.formData[this.field.name + j];
        }
        this.repeatablecounter[this.field.name] -= 1;
    }

    get errorMsgPlaceholders() {
        let lowerCaseClass = this.$translate.use() === 'de' ? '' : 'lowercase'; //in German field name should be in Uppercase
        if (this.field.name !== undefined && this.field.name === 'copyRightsRapido') {
            return {idx_0: `<span class="${lowerCaseClass}">{{"nui.ngrs.copyrights" | translate}}</span>`};
        }
        if (this.field.label === undefined || this.field.label.length <= 0) {
            let fieldLabel = (this.field.options !== undefined && this.field.options.length > 0) ? this.field.options[0].label: '';
            return {idx_0: `<span class="${lowerCaseClass}">{{::"${fieldLabel}" |translate}}</span>`};
        }
        if (this.field.mandatoryGroup !== undefined) {
            let mandatoryGroupFields = this.requestService.formFields.filter((el) => {
                return el.mandatoryGroup === this.field.mandatoryGroup && el.uiType != 'hidden'
            })
            let fieldLabels = mandatoryGroupFields.map(el => {
                return `<span class="${lowerCaseClass}">{{::"${el.label}" |translate}}</span>`
            });
            return {idx_0: fieldLabels.join()};
        }
        return {idx_0: `<span class="${lowerCaseClass}">{{::"${this.field.label}" |translate}}</span>`};
    }

    public isCopyrightField() {
        return this.field.name === 'copyrightDeclaration' || this.field.name === 'copyrights' || this.field.name === 'copyright';
    }

    public isRapidoCopyright() {
        return this.field.name === 'copyRightsRapido';
    }

    public isLoginComplianceStatement() {
        return this.field.name === 'complianceStatement' || this.field.name === 'billingComplianceStatement';
    }

    public isFieldHasLabel() {
        let optionsWithLabels = getValue(this.field, 'options', []).filter((option) => option.label !== undefined && this.$translate.instant(option.label) != '');
        return (optionsWithLabels.length > 0 || this.field.label);
    }

    /* public functions */
    public getFormFieldHtml() {
        if (!this.field || !this.fieldUiTypeHtml[this.field.uiType]) {
            // When uiType contains method to decide its type
            if (this.field.uiType.method) {
                this.field.uiType = this.field.uiType.method(this.data);
            } else {
                this.field.uiType = 'text';
            }
        }
        return this.fieldUiTypeHtml[this.field.uiType];
    }

    public getCatagories() {
        if (!this.field.options) {
            return [];
        }

        let array = this.dropdownOptions.map((value, index, array1) => this.parseCatagories(value)).filter(this.filterEmpty);
        return uniq(array);
    }

    public getCurrentDate() {
        let now = new Date();
        return dateFormat(now, "yyyy-mm-dd'T'HH:MM:ss");
    }

    private parseCatagories(option) {
        return option.category;
    }

    private filterEmpty(e) {
        return e;
    }

    public sendButtonClicked() {
        this.buttonClicked.emit(this.field.name);
    };

    public filterDatesUnbound(date) {
        if (!this.field) {
            return true;
        }

        /* check filter dates by allow in populator (params) */
        if (this.field.populator && this.field.populator.params && this.field.populator.params.allow) {
            return (this.field.populator.params.allow === FormBuilderEnums.FUTURE_DATES && date >= new Date().setHours(0, 0, 0, 0));
        }

        if (!this.field.options || this.field.options.length <= 0) {

            return true;
        }

        /* check filter dates by allow in populator (params) */
        if (this.field.populator && this.field.populator.params && this.field.populator.params.allow) {
            return (this.field.populator.params.allow === FormBuilderEnums.FUTURE_DATES && date >= new Date().setHours(0, 0, 0, 0));
        }

        if (!this.field.options || this.field.options.length <= 0) {
            return true;
        }

        let found = false;
        forEach(this.field.options, (option) => {
            if (!found) {
                found = (date.getDate() === option.day &&
                    date.getMonth() + 1 === option.month &&
                    date.getFullYear() === option.year);
            }
        });

        return found;

    }

    public validateMandatoryGroup() {
        let fieldWithValue = undefined;
		let numOfElementsWithSameMandatoryGroup = [];
        if (this.field.mandatoryGroup !== undefined) {
			numOfElementsWithSameMandatoryGroup = this.requestService.formFields.filter((el) => {
				return this.field.key !== el.key && el.uiType !== 'hidden' && el.mandatoryGroup === this.field.mandatoryGroup 

			});
            fieldWithValue = this.requestService.formFields.find((el) => {
                return el.uiType !== 'hidden' && el.mandatoryGroup === this.field.mandatoryGroup && this.formData[el.key] !== undefined && typeof this.formData[el.key] === "string" && this.formData[el.key].trim() !== ''
            });
        }
        return numOfElementsWithSameMandatoryGroup && numOfElementsWithSameMandatoryGroup.length>0 && fieldWithValue === undefined && this.field.mandatoryGroup !== undefined;
    }

    public get dropdownOptions() {
        if (this.filterSearchTerm) {
            return this.$filter('filter')(this.field.options as any, {'label': this.filterSearchTerm}, false);
        }
        return this.field.options;
    }

    public setAriaRequiredAttribute() {
        let el = document.getElementById('mandatory_' + this.field.key);
        if (el) {
            if (this.field.mandatory) {
                el.setAttribute('aria-required', 'true');

            }
        }
    }

    public getFieldTranslated() {
        let field =  this.$translate.instant(this.field.label);
        return this.$translate.instant('nui.aria.fulldisplay.howToGetIt.field', {field: field});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/formBuilder/field/formField.directive.ts